import { render, staticRenderFns } from "./LuckyRollsWinners.vue?vue&type=template&id=455874c0&"
import script from "./LuckyRollsWinners.vue?vue&type=script&lang=js&"
export * from "./LuckyRollsWinners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports